/** @format */

import {
  Box,
  Checkbox,
  InputAdornment,
  OutlinedInput,
  Stack,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { ClockIcon } from '@mui/x-date-pickers';
import EyeIcon from '@untitled-ui/icons-react/build/esm/Eye';
import SearchMdIcon from '@untitled-ui/icons-react/build/esm/SearchMd';
import { format, subDays, subHours } from 'date-fns';
import { Scrollbar } from 'src/components/scrollbar';
import { SeverityPill } from 'src/components/severity-pill';
import { formatDistanceToNow } from 'src/utils/parse';

const now = new Date();

const users = [
  {
    id: '5e887ac47eed253091be10cb',
    datetime: subDays(subHours(now, 7), 1).getTime(),
    byUser: 'Carson Darrin',
    description: 'Customer signed in',
    time: '5 minutes ago',
    status: 'inprocess'
  },
  {
    id: '5e887b209c28ac3dd97f6db5',
    datetime: subDays(subHours(now, 1), 2).getTime(),
    byUser: 'Fran Perez',
    description: 'Customer signed in',
    time: '5 minutes ago',
    status: 'success'
  },
  {
    id: '5e887b7602bdbc4dbb234b27',
    datetime: subDays(subHours(now, 3), 2).getTime(),
    byUser: 'Jie Yan Song',
    description: 'Updating action configure for event config (RUN5)',
    time: '5 minutes ago',
    status: 'inprocess'
  },
  {
    id: '5e86809283e28b96d2d38537',
    datetime: subDays(subHours(now, 4), 7).getTime(),
    byUser: 'Anika Visser',
    description: 'Updating action configure for event config (CHECK)',
    time: '5 minutes ago',
    status: 'success'
  },
  {
    id: '5e86805e2bafd54f66cc95c3',
    datetime: subHours(now, 7).getTime(),
    byUser: 'Miron Vitold',
    description: 'Update information of device (CNCMACDINEO1)',
    time: '5 minutes ago',
    status: 'success'
  }
];

const statusMap = {
  success: 'success',
  inprocess: 'info',
  canceled: 'warning',
  rejected: 'error'
};

export default function ActionLog({ open, handleClose }) {
  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xl">
      <DialogTitle>Action Log</DialogTitle>
      <DialogContent>
        <Box>
          <Stack alignItems="center" justifyContent="flex-end" direction="row" flexWrap="wrap" gap={2} sx={{ py: 3 }}>
            <OutlinedInput
              placeholder="Search"
              startAdornment={
                <InputAdornment position="start">
                  <SvgIcon>
                    <SearchMdIcon />
                  </SvgIcon>
                </InputAdornment>
              }
              sx={{ flexGrow: 1, maxWidth: '300px' }}
            />
          </Stack>
          <Scrollbar>
            <Table sx={{ minWidth: 700 }}>
              <TableHead>
                <TableRow>
                  <TableCell align="center" padding="checkbox">
                    <Checkbox />
                  </TableCell>
                  <TableCell align="center">Date time</TableCell>
                  <TableCell align="center">By user</TableCell>
                  <TableCell align="center">Description</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Time</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map((user) => {
                  const statusColor = statusMap[user.status] || 'warning';
                  return (
                    <TableRow hover key={user.id}>
                      <TableCell padding="checkbox">
                        <Checkbox />
                      </TableCell>

                      <TableCell align="center">{format(user.datetime, 'dd/MM/yyyy HH:mm:ss')}</TableCell>
                      <TableCell>{user.byUser}</TableCell>
                      <TableCell>{user.description}</TableCell>
                      <TableCell align="center">
                        <SeverityPill color={statusColor}>{user.status}</SeverityPill>
                      </TableCell>
                      <TableCell align="center">
                        <Stack alignItems="center" justifyContent="center" direction="row" spacing={1}>
                          <SvgIcon color="action" fontSize="small">
                            <ClockIcon />
                          </SvgIcon>
                          <Typography color="text.secondary" variant="caption">
                            {/* {user.time} */}

                            {formatDistanceToNow(user.datetime, 'trước')}
                          </Typography>
                        </Stack>
                      </TableCell>
                      <TableCell align="center">
                        <Button
                          component="a"
                          href={''}
                          startIcon={
                            <SvgIcon>
                              <EyeIcon />
                            </SvgIcon>
                          }
                          target="_blank"
                          variant="contained"
                          size="small"
                          color="info"
                        >
                          View
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Scrollbar>
          <TablePagination
            component="div"
            count={users.length}
            onPageChange={() => {}}
            onRowsPerPageChange={() => {}}
            page={0}
            rowsPerPage={5}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
